<template>
  <div class="menu">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="menu-title">
      菜单管理
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
<!--      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">-->
<!--        <search @onSearch="onSearch" placeholder="请输入菜单名搜索" />-->
<!--      </div>-->
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <a-button class="createrBtn" @click="onSearch">刷新</a-button>
      </div>
      <div style="display: inline-block;vertical-align: top;">
        <a-button v-if="hasPerm('/admin/system/menu/add')" class="createrBtn" @click="showCreateClick">新增菜单</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <menu-table ref="menuTable" />
    <!-- 新增菜单 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">新增菜单</div>
      <a-form-model ref="createMenu" v-bind="layout" :model="menuInfo" :rules="menuInfoRules">
        <a-form-model-item has-feedback label="菜单名称" prop="name">
          <a-input v-model="menuInfo.name" type="text" autocomplete="off" :maxLength="150" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="父级菜单" prop="parentId">
          <a-tree-select
            v-model="menuInfo.parentId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="MenuTreeData"
            :replaceFields="replaceFields"
            treeNodeFilterProp="title"
            placeholder="请选择父级菜单"
            allow-clear
            searchPlaceholder="请选择父级菜单"
            show-search
            tree-default-expand-all
            value="id"
            title="name"
            key="id"
          >
          </a-tree-select>
        </a-form-model-item>

        <a-form-model-item has-feedback label="类型" prop="type">
<!--          <a-input v-model="menuInfo.type" type="text" autocomplete="off" :maxLength="11" />-->
          <a-radio-group v-model="menuInfo.type" :default-value="1">
<!--            <a-radio :value="0">-->
<!--              目录-->
<!--            </a-radio>-->
            <a-radio :value="1">
              菜单
            </a-radio>
            <a-radio :value="2">
              按钮
            </a-radio>
            <a-radio :value="3">
              用户终端权限
            </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item has-feedback label="菜单路径" prop="url">
          <a-input v-model="menuInfo.url" type="text" autocomplete="off" :maxLength="150" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="请求路径" prop="perms">
          <a-input v-model="menuInfo.perms" type="text" autocomplete="off" :maxLength="150" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="文件路径" prop="path">
          <a-input v-model="menuInfo.path" type="text" autocomplete="off" :maxLength="150" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="菜单图标" prop="icon">
          <a-input v-model="menuInfo.icon" type="text" autocomplete="off" :maxLength="150" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="排序" prop="orderNum">
          <a-input-number v-model="menuInfo.orderNum" :min="0" :maxLength="11" />
        </a-form-model-item>
      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" @click="submitForm('createMenu')">新增</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import {CreateMenu, MenuList, MenuNavList} from "api/menu"

import search from "@/components/content/search/Search";
import MenuTable from './childComps/MenuTable';
import {hasPermission} from 'utils/hasPermission'

export default {
  name: 'Menu',
  components: {
    search,
    MenuTable
  },
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('菜单名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      menuInfo: {
        id: "",
        createBy: null,
        createTime: null,
        lastUpdateBy: "",
        lastUpdateTime: "",
        parentId: null,
        name: "",
        url: null,
        perms: null,
        type: 1,
        icon: "",
        orderNum: 0,
        delFlag: 0,
        parentName: null,
        level: null,
        children: null,
        ownerId: null
      },

      //父级菜单数据
      MenuTreeData:[],
      //对应自己的后端接口返回字段
      replaceFields: {
        children:'children',//后端数组层级的名字
        key:'id', //一般是id
        value: 'id',//onSelect(selectedKeys)的selectedKeys的参数值，便于获取然后返回给后端
        title: 'name'
      },


      menuInfoRules: {
        name: [{validator: validateNickname, trigger: 'change'}],
      }
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.$refs.menuTable.menuName = value;
      this.$refs.menuTable.getMenuListData()
    },
    // 显示新增菜单
    showCreateClick() {
      this.visible = !this.visible;
      this.getMenuNavListData();
      this.menuInfo = {
          createBy: null,
          createTime: null,
          lastUpdateBy: "",
          lastUpdateTime: "",
          parentId: null,
          name: "",
          url: null,
          perms: null,
          path: null,
          type: 1,
          icon: "",
          orderNum: 0,
          delFlag: 0,
          parentName: null,
          level: null,
          children: null,
          ownerId: null
      }
    },
    // 取消新增
    cancel() {
      console.log("取消新增");
      this.visible = !this.visible;
    },
    // 新增菜单
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */

    getMenuNavListData() {
      // this.loading = true;
      MenuNavList()
        .then(res => {
          console.log(res);
          console.log(res.data);
          if(res.data.length > 0) {
            // let arr = [];
            this.MenuTreeData = res.data;
            this.loading = false;
          } else {
            this.loading = false;
            this.menuList = []
            this.$message.error('没有查询到结果，请重试！');
          }
        })
        .catch(err => {
          // this.loading = false;
          console.log('+++++++++++++++err',err);
        })
    },
    create() {
      const vm = this;
      this.spinning = true
      CreateMenu(this.menuInfo.parentId, this.menuInfo.name
        , this.menuInfo.url, this.menuInfo.perms, this.menuInfo.path, this.menuInfo.type, this.menuInfo.icon, this.menuInfo.orderNum
      )
        .then(res => {
          console.log(res);
          vm.spinning = false
          if(res.message !== "success") {
            vm.$message.error(res.message);
          } else {
            vm.$message.success('新增菜单成功！');
            vm.spinning = false
            vm.visible = false;
            vm.onSearch(this.$refs.menuTable.menuName);

          }
        })
        .catch(err => {
          console.log(err);
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .menu {
    .menu-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
